// src/components/modals/app-modals/BaseModalApp.jsx

import Modal from 'react-modal';
if (typeof document !== 'undefined' && document.querySelector('#root')) {
  Modal.setAppElement('#root');
}

const BaseModalApp = ({
  isOpen,
  onRequestClose,
  contentLabel = 'App Modal',
  size, // 👈 nova prop opcional: "500px" | "750px" | "1000px"
  className = 'ReactModal__Content modal--app',
  overlayClassName = 'ReactModal__Overlay modal-overlay--app',
  children,
}) => {
  // 🔹 Afegim la classe corresponent segons el size
  const combinedClassName = size
    ? `${className} modal--${size}`
    : className;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      contentLabel={contentLabel}
      className={combinedClassName}
      overlayClassName={overlayClassName}
    >
      {children}
    </Modal>
  );
};

export default BaseModalApp;
